/*
 *                                                          /-> Deauthenticating -> [None]
 *                                     -> [Credentialed] -<
 *                                   /                      🤖 [ConnectedToRiver]
 * [None] -> EvaluatingCredentials -<  -> [None]
 *                                   \
 *                                     -> [ConnectedToRiver] -> DisconnectingFromRiver -> [None]
 */
export var AuthStatus;
(function (AuthStatus) {
    /** User is not authenticated or connected to the river client. */
    AuthStatus["None"] = "None";
    /** Transition state: None -> EvaluatingCredentials -> [Credentialed OR ConnectedToRiver]
     *  if a river user is found, will connect to river client, otherwise will just validate credentials.
     */
    AuthStatus["EvaluatingCredentials"] = "EvaluatingCredentials";
    /** User authenticated with a valid credential but without an active river stream client. */
    AuthStatus["Credentialed"] = "Credentialed";
    /** User authenticated with a valid credential and with an active river river client. */
    AuthStatus["ConnectedToRiver"] = "ConnectedToRiver";
    /** Transition state: ConnectedToRiver -> DisconnectingFromRiver -> None */
    AuthStatus["DisconnectingFromRiver"] = "DisconnectingFromRiver";
    /** Transition state: Credentialed -> Deauthenticating -> None */
    AuthStatus["Deauthenticating"] = "Deauthenticating";
})(AuthStatus || (AuthStatus = {}));
//# sourceMappingURL=login.js.map